import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { last } from 'rxjs';
import { GlassCountries } from 'src/app/utils/Constants';

@Component({
  selector: 'app-account-creation',
  templateUrl: './account-creation.page.html',
  styleUrls: ['./account-creation.page.scss'],
  standalone: false
})
export class AccountCreationPage implements OnInit {

form = this.fb.group({
    firstName: ["", Validators.required],
    lastName: ["", Validators.required],
    email: ['', [Validators.required, Validators.email]],
    country:  ["", Validators.required],
    company: [""],
    password: ['', [Validators.required]],
    confirmPassword: ["", [Validators.required]],
    policy: [false, [Validators.requiredTrue]]
});
selectedOption:boolean = false;
showConfirmPassword:boolean = false;
showPassword:boolean = false;
countries = GlassCountries;
constructor(private fb: FormBuilder, private modalController: ModalController,private cdr: ChangeDetectorRef) { 
  this.form.get('password')?.addValidators(
    this.passwordValidator('firstName', 'lastName')
  );
  
this.form.get('password')?.updateValueAndValidity();
//this.cdr.detectChanges();
}
ngOnInit() {
  this.form.statusChanges.subscribe(status => {
    this.selectedOption = status === 'VALID';
  });
}

checkLogin() {
  throw new Error('Method not implemented.');
}
closeLogin() {
  this.modalController.dismiss(null, 'cancel');
}
openMenu() {
  throw new Error('Method not implemented.');
}

get password() {
  return this.form.get('password');
}
cancel() {

}
togglePassword() {
  this.showPassword = !this.showPassword;
}
toggleConfirmPassword() {
  this.showConfirmPassword = !this.showConfirmPassword;
}

validate(){
  console.log("validated : "+ this.form.status);
  if(this.form.status == 'VALID') {
    if(this.form.get('password')?.value == this.form.get('confirmPassword')?.value) {
      //save user
    } else {
      console.log("Password mismatched");
      return;
    }
  }
 
}
passwordValidator(
  firstNameKey: string,
  lastNameKey: string
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.value;
    if (!password) return null;

    const parent = control.parent;
    const firstName = parent?.get(firstNameKey)?.value?.toLowerCase();
    const lastName = parent?.get(lastNameKey)?.value?.toLowerCase();

    const errors: any = {};

    if (password.length < 8) {
      errors.minLength = true;
    }

    if (!/[a-z]/.test(password)) {
      errors.lowercase = true;
    }

    if (!/[A-Z]/.test(password)) {
      errors.uppercase = true;
    }

    if (!/[0-9]/.test(password)) {
      errors.number = true;
    }

    if (
      (firstName && password.toLowerCase().includes(firstName)) ||
      (lastName && password.toLowerCase().includes(lastName))
    ) {
      errors.containsName = true;
    }

    return Object.keys(errors).length ? errors : null;
  };
}
 
}